<coin-v2-card
  padding="none"
  [rounding]="rounding()"
  (blur)="markAsTouched()">
  <div
    class="outline-container"
    [class.selected]="viewValue()"
    (click)="toggleCard()">
    <div class="checkbox-container">
      <coin-v2-checkbox
        [contrast]="viewValue()"
        [ngModel]="viewValue()"></coin-v2-checkbox>
    </div>
    <div class="content padding-{{ padding() }}">
      <ng-content></ng-content>
    </div>
  </div>
</coin-v2-card>
